export const en = {
    "k_a8b6fae2": "Wait for the page slice to complete rendering",
    "k_a1296606": "This method can ensure that subsequent logical page slices are rendered complete",
    "k_eed42cbc": "The page type added is wrong!",
    "k_db11b1a5": "Please preview it on the custom domain name product end",
    "k_4e3cd06d": "Test version failed to load",
    "k_a5866f2b": "Preparing the AI page development environment",
    "k_f5f44245": "Stable version (stable)",
    "k_c059f600": "Current page address:{arg_0}",
    "k_530f9d66": "Error time:{arg_0}",
    "k_e907bac4": "Copy to clipboard",
    "k_206be49d": "Select editor version",
    "k_6bd0be7e": "Please try selecting a new version, or copy the following information and contact the assistant:",
    "k_ef6f61bc": "Click to copy",
    "k_c485050b": "Invalid",
    "k_310d2b1": "After selection, editor resources will be reloaded and invalid versions will be disabled",
    "k_223445e": "[customRequire]{arg_0} is not implemented",
    "k_f07e8318": "Unable to find configuration for data source \"{arg_0}\"",
    "k_e8a23bc9": "Don't have permission to call, click",
    "k_67415b6": "Global context",
    "k_eec4167d": "Pass on the current page",
    "k_4f2df9f9": "Get embedded instances",
    "k_867eb613": "Embedded examples pass",
    "k_a59ce05f": "Get the current page",
    "k_463424bc": "No interface is configured for this data source",
    "k_7fc7e921": "Generate default parameters",
    "k_6fdf39b0": "Generating batch request parameters",
    "k_14892555": "View the document",
    "k_d3897868": "This data source supports custom data source methods, and it is recommended to use custom data source methods to make requests for a better experience",
    "k_7fec96b5": "Failed to obtain collection information",
    "k_384a961a": "Message sender",
    "k_dfc47f5e": "Platform provides",
    "k_69ba7ebc": "There is no enterprise WeChat application provided by the platform",
    "k_43efac28": "Customizable enterprise WeChat application",
    "k_5e465902": "Dynamically set",
    "k_908df45f": "Fixedly arranged",
    "k_65332d4e": "View details",
    "k_19120c70": "Text card",
    "k_e6c26c25": "Text content",
    "k_bd48a898": "Markdown content",
    "k_a357ae94": "Supported markdown syntax",
    "k_bba3cfb4": "You can support line breaks and subsets of mark syntax, such as: [View](http://x.y.z), length limit of 2048",
    "k_3832fa83": "Card title, length limit 128",
    "k_f015816b": "Card content, length limit 512",
    "k_316c81b0": "Click on the link that the card jumps, the length limit is 2048",
    "k_a25633a9": "Button text",
    "k_ffe9fec0": "Length Limit 4",
    "k_ead29e14": "The current project has no pages, and the online components in the navigation bar cannot preview scenarios using data sources",
    "k_95203dd8": "You can support line breaks and hyperlinks, such as: View &lt;a href='http://x.y.z';&gt; details</a>, length limit 2048"
};
